import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Checkbox } from '@/components/ui/checkbox';
import { useGroupOfPeople } from '../hooks/useGroupOfPeople';

export const SelectGroupOfPeopleButton = ({ onSelectChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data, loading, fetchData } = useGroupOfPeople();
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [selectedPersonIds, setSelectedPersonIds] = useState([]);

  const selectedGroup = data?.find(group => group.id?.toString() === selectedGroupId);

  // Agrega el useEffect para seleccionar todos los checkboxes por defecto
  useEffect(() => {
    if (selectedGroup?.people) {
      setSelectedPersonIds(selectedGroup.people.map(person => person.id));
    }
  }, [selectedGroup]);

  const handleOpenModal = () => {
    fetchData(false);
    setIsOpen(true);
  };

  const handleConfirm = () => {
    if (onSelectChange) {
      onSelectChange({
        group: selectedGroup,
        people: selectedGroup?.people?.filter(p => selectedPersonIds.includes(p.id))
      });
    }
    setIsOpen(false);
    setSelectedGroupId('');
    setSelectedPersonIds([]);
  };

  return (
    <>
      <Button onClick={handleOpenModal} loading={loading} className="mt-4">
        Seleccionar grupo de personas
      </Button>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Seleccionar Grupo y Persona</DialogTitle>
            <DialogDescription>
              Seleccione un grupo y las personas que desea agregar.
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            {/* Selección de Grupo */}
            <Select
              value={selectedGroupId}
              onValueChange={(value) => {
                setSelectedGroupId(value);
                setSelectedPersonIds([]);
              }}
            >
              <SelectTrigger>
                <SelectValue placeholder="Seleccionar Grupo" />
              </SelectTrigger>
              <SelectContent>
                {loading ? (
                  <SelectItem value="loading" disabled>Cargando...</SelectItem>
                ) : (
                  data?.map(group => (
                    <SelectItem key={group.id} value={group.id.toString()}>
                      {group.name}
                    </SelectItem>
                  ))
                )}
              </SelectContent>
            </Select>
            {/* Selección de Personas con Checkboxes */}
            {selectedGroup && selectedGroup.people && (
              <div className="flex flex-col gap-2">
                {selectedGroup.people.map(person => (
                  <div key={person.id} className="flex items-center space-x-2">
                    <Checkbox
                      id={`person-${person.id}`}
                      checked={selectedPersonIds.includes(person.id)}
                      onCheckedChange={(checked) => {
                        if (checked) {
                          setSelectedPersonIds([...selectedPersonIds, person.id]);
                        } else {
                          setSelectedPersonIds(selectedPersonIds.filter(id => id !== person.id));
                        }
                      }}
                    />
                    <label
                      htmlFor={`person-${person.id}`}
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      {person.name}
                    </label>
                  </div>
                ))}
              </div>
            )}
          </div>
          <DialogFooter>
            <Button
              onClick={handleConfirm}
              disabled={!selectedGroupId || selectedPersonIds.length === 0}
            >
              Confirmar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};